import {ApiClient} from "../utils/apiClient";
import { AlertTypes, USER_ERROR } from  "@leap4/frontend";
import {setAlert} from "./alert"
import {Dispatch} from "redux";
import {
    createNewOrganizationUrl,
    deleteOwnershipUrl,
    OrganizationsBaseUrl,
    OrganizationsSubmitChanges, OrganizationsUpdatePartners, ownershipsSupply,
    AddOwnershipBaseUrl,
    UsersBaseUrl,
    getClientForOrganizationUrl
} from "../config/generals";
import {IOwnership} from "@leap4/general-common";
import {IOrganization} from "../components/organizations/interfaces/IOrganization";
import {IFormData} from "../components/users/AddEditUser/AddUser";
import {IPublisherLogins} from "../components/publisherLogins/interfaces/IPublisherLogins";
import {CreateClientDto} from "../components/organizations/Organization/Client/IClient";



export const getAllOrganizations = async (dispatch: Dispatch) => {
    try {
        const res = await ApiClient.get( OrganizationsBaseUrl );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const getAllTags = async (dispatch: Dispatch, date: Date, id: string) => {
    try {
        const res = await ApiClient.post( ownershipsSupply,{Date: date, id: id} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const addOwnershipToDB = async (dispatch: Dispatch, ownership: IOwnership) => {
    try {
        const res = await ApiClient.post( AddOwnershipBaseUrl,{ownership} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const submitAndDeleteOrganization = async (dispatch: Dispatch, organization: IOrganization) => {
    try {
        const res = await ApiClient.post( OrganizationsSubmitChanges,{organization: organization} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const updatePartners = async (dispatch: Dispatch, publisherLogins: IPublisherLogins) => {
    try {
        const res = await ApiClient.post( OrganizationsUpdatePartners,{publisherLogins: publisherLogins} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const createNewOrganization = async (dispatch: Dispatch, name: string) => {
    try {
        const res = await ApiClient.post( createNewOrganizationUrl,{name: name} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const getUserById = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.get( UsersBaseUrl + "/" + id);
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const updateUserId = async (dispatch: Dispatch, id: string, organizations: string[]) => {
    try {
        const res = await ApiClient.post( UsersBaseUrl + "/submit", {userId: id, organizations: organizations});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const createUser = async (dispatch: Dispatch, user: IFormData) => {
    try {
        const res = await ApiClient.post( UsersBaseUrl + "/create", {user: user});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const deleteOwnership = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.post( deleteOwnershipUrl, {id: id});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const getClientForOrganization = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.get(getClientForOrganizationUrl + "/" + id);
        return res.data;
    } catch (err: any) {
        if (err.response?.status === 400 || err.response?.status === 404) {
            return null;
        }

        dispatch({
            type: USER_ERROR,
            payload: {},
        });
        dispatch(setAlert("Couldn't fetch client", AlertTypes.FAILURE) as any);
        return null;
    }
}

export const postNewClient = async (
    dispatch: Dispatch,
    dto: CreateClientDto
) => {
    try {
        const res = await ApiClient.post(getClientForOrganizationUrl, dto);
        return res.data;
    } catch (err: any) {
        dispatch({type: USER_ERROR, payload: {}});
        dispatch(
            setAlert(
                err.response?.data?.message || "Couldn't create client",
                AlertTypes.FAILURE
            ) as any
        );
        return null;
    }
};

export const regenerateClient = async (
    dispatch: Dispatch,
    organizationId: string,
) => {
    try {
        const res = await ApiClient.post(
            `${getClientForOrganizationUrl}/${organizationId}/regenerate`,
        );
        return res.data;
    } catch (err: any) {
        dispatch({type: USER_ERROR, payload: {}});
        dispatch(
            setAlert(
                err.response?.data?.message || "Couldn't regenerate client",
                AlertTypes.FAILURE,
            ) as any,
        );
        return null;
    }
};
